<template>
  <div class="model">
    <el-button class="new-btn" type="primary" size="mini" @click="addRow">新增一行</el-button>
    <el-table :data="tableData" height="600" style="width: 100%">
      <el-table-column label="模型编号" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px" v-if="scope.row.isEdit == 0">{{ scope.row.modelId }}</span>
          <el-input v-model="scope.row.modelId" v-else disabled></el-input>
        </template>
      </el-table-column>
      <el-table-column label="模型名称">
        <template slot-scope="scope">
          <span v-if="scope.row.isEdit == 0">{{ scope.row.modelName }}</span>
          <el-input v-model="scope.row.modelName" v-else></el-input>
        </template>
      </el-table-column>
      <el-table-column label="模型长(dimension X)">
        <template slot-scope="scope">
          <span v-if="scope.row.isEdit == 0">{{ scope.row.modelSizeY }}</span>
          <el-input v-model="scope.row.modelSizeY" v-else></el-input>
        </template>
      </el-table-column>
      <el-table-column label="模型宽(dimension Y)">
        <template slot-scope="scope">
          <span v-if="scope.row.isEdit == 0">{{ scope.row.modelSizeX }}</span>
          <el-input v-model="scope.row.modelSizeX" v-else></el-input>
        </template>
      </el-table-column>
      <el-table-column label="模型类型">
        <template slot-scope="scope">
          <span v-if="scope.row.isEdit == 0">{{ getOptionsText(scope.row.modelType) }}</span>
          <el-select v-else v-model="scope.row.modelType"><el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option></el-select>
        </template>
      </el-table-column>
      <el-table-column label="电池簇及插箱" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="setBatteryClusterConfig(scope.row)">{{ scope.row.cellClustersBoxsStatus == 1 ? '已配置' : '未配置' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.isEdit == 0">
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </span>
          <span v-else>
            <el-button size="mini" type="success" @click="confirm(scope.$index, scope.row)">确定</el-button>
            <el-button size="mini" type="warning" @click="cancel(scope.$index, scope.row)">取消</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 电池簇-->
    <el-drawer title="编辑电池簇" :visible.sync="showBatteryCluster" @close="closeBattery" :close-on-press-escape="false" :wrapperClosable="false" direction="rtl" size="50%">
      <div class="wrap-battery">
        <div>
          <el-button class="new-btn-battery" type="primary" size="mini" @click="addRowBatteryCluster">新增电池簇</el-button>
          <el-button class="save-btn-battery" type="primary" size="mini" @click="saveBatteryCluster">保存</el-button>
          <el-table :data="batteryClusterData" height="40vh">
            <el-table-column label="簇编号" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.cluId" disabled></el-input>
              </template>
            </el-table-column>
            <el-table-column label="簇名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.cluName"></el-input>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header" slot-scope="scope">
                <span>是否显示</span>
                <el-switch v-model="showAllBattery" @change="res=>changeSwitch(1,res,scope.row)"></el-switch>
              </template>
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isShow"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="deleteBattery(scope.$index, scope.row)">删除</el-button>
                <el-button size="mini" type="text" @click="configBox(scope.$index, scope.row)">配置插箱</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="battery-box" v-if="batteryBoxData.length > 0">
          <el-button class="new-btn-battery" type="primary" size="mini" @click="addRowBox">新增插箱</el-button>
          <!-- <el-button class="save-btn-battery" type="primary" size="mini" @click="saveBox">保存</el-button> -->
          <el-table :data="batteryBoxData" height="40vh">
            <el-table-column label="插箱编号" width="150">
              <template slot-scope="scope">
                <el-input v-model="scope.row.batteryBoxId" disabled></el-input>
              </template>
            </el-table-column>
            <el-table-column label="插箱名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.batteryBoxName"></el-input>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header" slot-scope="scope">
                <span>是否显示</span>
                <el-switch v-model="showAllBox" @change="res=>changeSwitch(2,res,scope.row)"></el-switch>
              </template>
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isShow"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="deleteBox(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import GROUPAPI from '@/api/group';
import { getInfo } from '@/utils/auth';
import API from '@/api/glconfig';
export default {
  components: {},
  data() {
    return {
      options: [],
      tableData: [],
      showBatteryCluster: false,
      batteryClusterData: [], //电池簇
      batteryBoxData: [], //插箱
      showAllBattery: true,
      showAllBox: true,
      currentRow: {}
    };
  },
  watch: {},
  methods: {
    //初始化
    init() {
      this.getSwitchSearchCodes(28);
      this.searchSimulationModelList();
    },
    //获取optionsText
    getOptionsText(id) {
      let text = '';
      this.options.forEach(item => {
        if (item.id == id) {
          text = item.name;
        }
      });
      return text;
    },
    //新增一行
    addRow() {
      this.isEdit = 1;
      let res = 0;
      this.tableData.forEach(item => {
        if (!item.modelId) {
          res = 1;
        }
      });
      if (res) {
        this.$message.warning('请保存模型信息');
        return false;
      }
      this.tableData.push({ isEdit: 1, modelId: '', modelName: '', modelSizeY: '', modelSizeX: '', modelType: '', cellClustersBoxsStatus: '' });
    },
    confirm(index, row) {
      this.tableData[index].isEdit = 0;
      this.addSimulationModel(row);
    },
    cancel(index, row) {
      this.tableData[index].isEdit = 0;
    },

    //模型数据转换
    toTableData(data) {
      let modelSize = '';
      let tableData = [];
      data.forEach(item => {
        item.isEdit = 0;
        item.cellClustersBoxsStatus = 0;
        if (item.cellClustersBoxs) {
          item.cellClustersBoxsStatus = item.cellClustersBoxs.cellClusters.length > 0 ? 1 : 0;
        }
        modelSize = item.modelSize.split(',');
        item.modelSizeX = modelSize[0];
        item.modelSizeY = modelSize[1];
        tableData.push(item);
      });
      return tableData;
    },
    //获取模型列表
    searchSimulationModelList() {
      API.searchSimulationModelList().then(res => {
        if (res.data.code == 200) {
          let tmp = res.data.data;
          this.tableData = this.toTableData(tmp);
        }
      });
    },
    //获取切换类型
    getSwitchSearchCodes(number) {
      let self = this;
      let params = {
        codesType: number
      };
      GROUPAPI.searchCodes(params).then(res => {
        if (res.data.code == 200) {
          self.options = res.data.data;
        }
      });
    },
    handleEdit(index, row) {
      this.tableData.map(item=>{
        item.isEdit = 0;
      })
      this.tableData[index].isEdit = 1;
    },
    handleDelete(index, row) {
      if (row.modelId) {
        //保存数据
        this.$confirm('确定要删除此记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
          this.deleteSimulationModel(row.modelId);
        });
      } else {
        this.tableData.splice(index, 1);
      }
    },
    //删除仿真模型
    deleteSimulationModel(modelId) {
      API.deleteSimulationModel({ modelId: modelId }).then(res => {
        this.searchSimulationModelList();
      });
    },
    //新增仿真模型
    addSimulationModel(row) {
      if (row.modelId) {
        this.updateSimulationModel(row);
        return true;
      }
      let params = {};
      params.cellClustersBoxs = row.cellClustersBoxs;
      params.modelId = row.modelId;
      params.modelName = row.modelName;
      params.modelSize = row.modelSizeX + ',' + row.modelSizeY;
      params.modelType = row.modelType;

      API.addSimulationModel(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchSimulationModelList();
        }
      });
    },
    //修改仿真模型
    updateSimulationModel(row) {
      let params = {};
      params.cellClustersBoxs = row.cellClustersBoxs;
      params.modelId = row.modelId;
      params.modelName = row.modelName;
      params.modelSize = row.modelSizeX + ',' + row.modelSizeY;
      params.modelType = row.modelType;

      API.updateSimulationModel(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchSimulationModelList();
        }
      });
    },
    //配置电池簇及插箱
    setBatteryClusterConfig(row) {
      this.showBatteryCluster = true;
      this.currentRow = row;
      if(row.cellClustersBoxs && row.cellClustersBoxs.hasOwnProperty('cellClusters')){
        this.batteryClusterData = JSON.parse(JSON.stringify(row.cellClustersBoxs.cellClusters));
      }else{
        this.batteryClusterData = [];
      }
      this.batteryBoxData = [];
    },
    //保存电池簇
    saveBatteryCluster() {
      if(this.currentRow.cellClustersBoxs==null){
        this.currentRow.cellClustersBoxs = {}
      }
      this.currentRow.cellClustersBoxs.cellClusters = this.batteryClusterData;
      this.saveBox();
      this.updateSimulationModel(this.currentRow);
    },
    //新增一行电池簇
    addRowBatteryCluster() {
      let len = parseInt(this.batteryClusterData.length);
      len = len + 1;
      this.batteryClusterData.push({ cluId: 'clu' + len, cluName: '', isShow: true, batteryBox: [] });
    },
    //新增一行插箱
    addRowBox() {
      let len = parseInt(this.batteryBoxData.length);
      len = len + 1;
      this.batteryBoxData.push({ batteryBoxId: '' + len, batteryBoxName: '', isShow: true });
    },
    //保存当前插箱数据
    saveBox() {
      this.batteryClusterData.batteryBox = this.batteryBoxData;
      this.currentRow.cellClustersBoxs.cellClusters = this.batteryClusterData;
    },
    //配置插箱
    configBox(index, row) {
      this.batteryBoxData = row.batteryBox;
      if(this.batteryBoxData.length==0){
        this.addRowBox();
      }
    },
    //删除电池簇
    deleteBattery(index,row){
      this.batteryClusterData.splice(index,1);
    },
    //删除插箱
    deleteBox(index,row){
      this.batteryBoxData.splice(index,1);
    },
    //关闭电池簇弹窗
    closeBattery(){
      this.batteryBoxData = [];
      this.batteryClusterData = [];
    },
    //切换是否显示开关
    changeSwitch(index,res,row){
      if(index==1){
        if(this.batteryClusterData.length>0){
            this.batteryClusterData.map(item=>{
                item.isShow = res;
            })
        }
        return true;
      }
      if(index==2){
        if(this.batteryBoxData.length>0){
            this.batteryBoxData.map(item=>{
                item.isShow = res;
            })
        }
        return true;
      }
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped="scoped">
.model {
  .new-btn {
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .wrap-battery {
    margin: 20px;
    margin-top: 0px;
    .new-btn-battery {
      margin-bottom: 10px;
    }
    .save-btn-battery {
      margin-left: 20px;
      margin-bottom: 10px;
    }
    .battery-box{
      margin-top: 20px;;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/template/components/model.vue